/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the loading state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SET_LOADING = state => {
    state.error = null
    state.uploaded = false
    state.loading = true
}

/**
 * Reset the loading state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_LOADING = state => {
    state.loading = false
}

/**
 * Assign the payload data to the state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const GET_DATA_SUCCESS = (state, payload) => {
    state.data.date = payload.date
    state.data.file_name = payload.file_name
    state.data.summary = payload.summary
    state.data.table_data = payload.table_data
    state.meta.rentroll_file_id = payload.meta.rentroll_file_id
    state.meta.assignment_options = payload.meta.assigment_options
    state.mapping = payload.mapping
    state.uploaded = true
}

/**
 * Paginate forward
 *
 * @param  {Object} state
 * @return {Promise}
 */
const PAGINATE_FORWARD = state => {
    state.pagination.currentPage++
}

/**
 * Paginate back
 *
 * @param  {Object} state
 * @return {Promise}
 */
const PAGINATE_BACKWARD = state => {
    state.pagination.currentPage--
}

/**
 * Go to the first page
 *
 * @param  {Object} state
 * @return {Promise}
 */
const PAGINATE_FIRST = state => {
    state.pagination.currentPage = 1
}

/**
 * Go to the last page
 *
 * @param  {Object} state
 * @return {Promise}
 */
const PAGINATE_LAST = state => {
    let rows = state.data.table_data.meta.number_of_rows + 1
    let limit = state.pagination.pageLimit

    state.pagination.currentPage = Math.ceil(rows / limit)
}

/**
 * Handle file upload failure (rejected)
 *
 * @param  {Object} state
 * @param  {Object} message
 * @return {Promise}
 */
const FILE_REJECTED = (state, error) => {
    state.error = error.message
    state.meta.rentroll_file_id = error.rentroll_file_id
    state.uploaded = false
}

/**
 * Handle file upload failure (other)
 *
 * @param  {Object} state
 * @param  {Object} message
 * @return {Promise}
 */
const FILE_FAILED = (state, message) => {
    state.error = message
    state.uploaded = false
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Set the remapping state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SET_UPDATE_MAPPING = state => {
    state.remapping = true
}

/**
 * Reset the remapping state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_UPDATE_MAPPING = state => {
    state.remapping = false
}

/**
 * Set the new mapping and data payload to the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const LOAD_NEW_MAPPING = (state, payload) => {
    state.data.summary = payload.summary
    state.data.table_data = payload.table_data
    state.meta.assignment_options = payload.meta.assigment_options
    state.mapping = payload.mapping
}

/**
 * Change the tab
 *
 * @param  {Object} state
 * @param  {Number} tab
 * @return {Promise}
 */
const CHANGE_TAB = (state, tab) => {
    state.showTab = tab
}

/**
 * Set the importing state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const ATTEMPT_IMPORT = (state) => {
    state.attemptingImport = true
}

/**
 * Reset the importing state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_ATTEMPT_IMPORT = state => {
    state.attemptingImport = false
}

const REQUEST_FILE_ASSISTANCE = state => {
    state.assistanceRequested = true
}

const RESET_REQUEST_FILE_ASSISTANCE = state => {
    state.assistanceRequested = false
}

const SUPPORT_REQUEST_SUCCESS = (state, message) => {
    state.assistanceMessage = message
}

const SUPPORT_REQUEST_FAILURE = (state, message) => {
    state.assistanceMessage = message
}

export default {
    CHANGE_TAB,
    RESET_STATE,
    FILE_FAILED,
    SET_LOADING,
    RESET_LOADING,
    FILE_REJECTED,
    PAGINATE_LAST,
    ATTEMPT_IMPORT,
    PAGINATE_FIRST,
    LOAD_NEW_MAPPING,
    GET_DATA_SUCCESS,
    PAGINATE_FORWARD,
    PAGINATE_BACKWARD,
    SET_UPDATE_MAPPING,
    RESET_UPDATE_MAPPING,
    RESET_ATTEMPT_IMPORT,
    REQUEST_FILE_ASSISTANCE,
    SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE,
    RESET_REQUEST_FILE_ASSISTANCE
}



// WEBPACK FOOTER //
// ./src/state/modules/rent-roll-importer/mutations.js